import { Api, Codes } from '../api';
import store from '../store';
import { ROLES } from '../constants/role';
class SL {
  constructor() {
    this.store = store;
    this.infoPromise;
  }
  get infoData() {
    return this.store.state.slLoginData;
  }
  getInfo() {
    if (this.infoPromise) {
      return this.infoPromise;
    } else if (this.infoData && Object.keys(this.infoData).length) {
      return new Promise(resolve => {
        resolve(this.infoData);
      });
    } else {
      return (this.infoPromise = new Promise((resolve, reject) => {
        Api.get.getSLInfo().then(res => {
          this.infoPromise = null;
          if (res.status === Codes.SUCCESS) {
            let data = res.data;
            this.store.dispatch('setLoginData', {
              role: ROLES.SL,
              data: data
            });
            resolve(this.infoData);
          }
        });
      }));
    }
  }
}
export default new SL();
